import { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import { Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import { buildActivityCard, getActivityOptions, getGameSettings } from '../../../services/activity/activity-service';
import { calculateDurations, playActiveSession } from '../../../services/game-session/game-session-service';
import { getEntity } from '../../../services/entity/entity-service';

import Button from '../../components/button/button';
import FormSection from '../../components/form-section/form-section';
import Input from '../../components/input/input';
import InputRadio from '../../components/input-radio/input-radio';
import GameIcon from '../../components/game-icon/game-icon';
import Pill from '../../components/pill/pill';
import PositionIcon from '../../components/position-icon/position-icon';
import PlayerDashboardButtons from '../../components/player-dashboard-buttons/player-dashboard-buttons';

import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

import { toast } from 'react-toastify';
import { withWhiteLabelContext } from 'react-whitelabel';

import {
  createGameSession,
  getGameSession,
  getGameSessions,
  resetGameSessionState,
  updateGameSession,
} from '../../../modules/game_session';

import {
  SESSION_TYPES,
  updateSessionOutOfGymStatus,
  getSessionOutOfGymStatus,
} from '../../../modules/game_session_api';

import { createGameSessionActivity, getGameSessionActivity } from '../../../modules/game_session_activity';
import { updatePlayer } from '../../../modules/player';
import { getGames } from '../../../modules/system/game';
import { getDifficulties } from '../../../modules/system/difficulty';
import { getLevels } from '../../../modules/system/level';
import { getPositions } from '../../../modules/system/position';
import { getSettings } from '../../../modules/system/setting';
import { getSkills } from '../../../modules/system/skill';
import { getGameSkills } from '../../../modules/system/game_skill';
import { getGameSkillPositionData } from '../../../modules/system/game_skill_position_api';

import { playerHasSessions } from '../../../modules/player_game_session_api';

import { setPageTitle } from '../../../modules/application/pages';

import './session-designer.css';
import InputSelect from '../../components/input-select/input-select';

function make_array_flat_and_unique(input_array) {
  return new Set([].concat(...input_array));
}

function createUniqueSkillPositionList(game_skill_position) {
  const skillPosCouples = [];
  const availSkills = [];

  for (const index in game_skill_position) {
    const gameData = game_skill_position[index];

    for (const bIndex in gameData) {
      const data = gameData[bIndex];
      const skillPosString = data['skill_id'] + ',' + data['position_id'];

      if (skillPosCouples.indexOf(skillPosString) === -1) {
        skillPosCouples.push(skillPosString);
      }

      if (availSkills.indexOf(data['skill_id']) === -1) {
        availSkills.push(data['skill_id']);
      }
    }
  }

  return [skillPosCouples, availSkills];
}

class SessionDesigner extends Component {
  constructor(props) {
    super(props);

    let homePlayInitialStatus = false;

    const history = this.props.history;

    let returnRoute = '';
    if (history && history.location && history.location.returnRoute) {
      returnRoute = history.location.returnRoute;

      if (returnRoute.includes('homePlay')) {
        homePlayInitialStatus = true;
      }
    }

    this.state = {
      owner: this.props.currentUserId,

      name: '',
      notes: '',
      skill: '',
      position: '',
      difficulty: '',
      game: '',
      isTemplate: true,

      activities: [],

      player: this.props.location.player || {},

      isEdit: false,
      isUpdatedSession: false,

      showPlayerModal: false,
      showConfirmSaveModal: false,

      showActivitySettingsModal: false,
      focusedActivity: {},
      focusedActivitySettings: {},
      availableSkills: [],
      sessionActivated: false,
      gameSession: {},
      submitting: false,
      isAssignedForOOG: false,
      isAssignedForHomePlay: homePlayInitialStatus,
      changedOOGAssignment: false,
    };

    this.archiveSession = this.archiveSession.bind(this);
    this.onClickPlayActiveSession = playActiveSession.bind(this);
  }

  async UNSAFE_componentWillMount() {
    const { player } = this.state;
    const { label } = this.props;
    this.props.dispatch(resetGameSessionState());
    this.props.dispatch(setPageTitle(player.id ? player.name : 'Session Designer'));

    this.props.dispatch(getSkills());
    this.props.dispatch(getPositions([{ platform_id: `${label.platform.platform_id}` }]));
    this.props.dispatch(getDifficulties());
    this.props.dispatch(getLevels());
    this.props.dispatch(getSettings());
    this.props.dispatch(getGames([]));
    this.props.dispatch(getGameSkills());

    const gameSkillPositionData = await getGameSkillPositionData();

    if (player.id) {
      const playerHasAssignedSessions = await playerHasSessions(player.id);

      if (playerHasAssignedSessions && playerHasAssignedSessions.data) {
        this.setState({ player_has_assigned_sessions: playerHasAssignedSessions.data.has_assigned_sessions });
      }
    }

    const skillPositionInfo = createUniqueSkillPositionList(gameSkillPositionData.data.games);
    const validGameSkillPositions = skillPositionInfo[0];
    const availSkills = skillPositionInfo[1];

    this.setState({
      game_skill_position: gameSkillPositionData.data.games,
      validGameSkillPositions: validGameSkillPositions,
      availableSkills: availSkills,
    });
  }

  async updateOutOfGymStatus() {
    const { isAssignedForOOG } = this.state;

    const newIsAssignedForOOG = !isAssignedForOOG;

    this.setState({
      isAssignedForOOG: newIsAssignedForOOG,
      changedOOGAssignment: true,
    });
  }

  async updateHomePlayStatus() {
    const { isAssignedForHomePlay } = this.state;

    const newIsAssignedForHomePlay = !isAssignedForHomePlay;

    this.setState({
      isAssignedForHomePlay: newIsAssignedForHomePlay,
      changedHomePlayAssignment: true,
    });
  }

  componentDidMount() {
    const { currentUserId } = this.props;
    const { player } = this.state;

    if (this.props.match.params.id) {
      this.props.dispatch(getGameSession(this.props.match.params.id)).then(async (gameSession) => {
        if (gameSession.body.owner !== currentUserId) {
          window.history.back();
          return;
        }

        if (player.id) {
          const currentOutOfGymStatus = await getSessionOutOfGymStatus(
            player.id,
            gameSession.body.id,
            SESSION_TYPES.OUT_OF_GYM
          );

          if (currentOutOfGymStatus && currentOutOfGymStatus.data && currentOutOfGymStatus.data.success) {
            this.setState({ isAssignedForOOG: currentOutOfGymStatus.data.status });
          }
        }

        if (player.id) {
          const currentHomePlayStatus = await getSessionOutOfGymStatus(
            player.id,
            gameSession.body.id,
            SESSION_TYPES.HOME_PLAY
          );

          if (currentHomePlayStatus && currentHomePlayStatus.data && currentHomePlayStatus.data.success) {
            this.setState({ isAssignedForHomePlay: currentHomePlayStatus.data.status });
          }
        }

        gameSession.body.game_session_activities.forEach((activityId) => {
          this.props.dispatch(getGameSessionActivity(activityId)).then((activity) => {
            const { activities } = this.state;
            const _activity = {
              skill: activity.body.skill,
              position: activity.body.position,
              difficulty: activity.body.difficulty || 1,
              level: activity.body.level,
              game: activity.body.game,
              settings: activity.body.settings,
            };

            activities.push(_activity);
            this.setState({ activities: activities });
          });
        });
        this.setState({ gameSession: gameSession.body, isEdit: true });
      });
    }
  }

  componentDidUpdate() {
    if (this.props.gameSession.id !== this.state.id && !this.state.isEdit) {
      this.setState({ isEdit: true, ...this.props.gameSession });
    }
  }

  successRoute = () => {
    let route = 'sessionBank';

    if (this.state.player.id) {
      route = `player/${this.state.player.id}/${route}`;
    }

    return `/${route}`;
  };

  async submit(isConfirmEdit) {
    if (this.state.submitting) {
      return;
    }
    this.setState({ submitting: true });
    const { dispatch } = this.props;
    const {
      owner,
      name,
      notes,
      activities,
      gameSession,
      isTemplate,
      isEdit,
      isUpdatedSession,
      player_has_assigned_sessions,
      isAssignedForHomePlay,
      changedOOGAssignment,
    } = this.state;

    const { player } = this.state;

    const gameSessionModel = {
      owner,
      name,
      notes,
      is_template: isTemplate,
    };

    const gameSessions = await getEntity(
      dispatch,
      getGameSessions([{ owner_id: this.props.currentUserId }, { name: `"${encodeURIComponent(name)}"` }]),
      true
    );

    const sessionNameExistsMessage = `Session with name '${this.state.name}' already exists.`;

    if (isEdit && !isUpdatedSession) {
      const nameExists = gameSessions.find(async (_gameSession) => {
        if (gameSession.id === _gameSession.id) {
          return false;
        }
        // same object or unchanged
        if (
          (!isUpdatedSession && gameSession.id === _gameSession.id) ||
          (!isUpdatedSession && name === gameSession.name)
        ) {
          this.setState({ submitting: false });
          return false;
        }
        if (this.state.name === _gameSession.name && this.state.id !== _gameSession.id) {
          this.toastError(sessionNameExistsMessage);
          this.setState({ submitting: false });
          return _gameSession;
        }
        this.setState({ submitting: false });
        return false;
      });

      const homePlayUpdateChange = await updateSessionOutOfGymStatus(
        player.id,
        this.props.gameSession.id,
        SESSION_TYPES.HOME_PLAY,
        isAssignedForHomePlay
      );

      if (nameExists) {
        if (changedOOGAssignment || homePlayUpdateChange) {
          this.props.history.push(`${this.successRoute()}?message=Updated game session! ${this.state.name}`);
          return;
        }
        this.setState({ submitting: false });
        return;
      }

      const entityResponse = await getEntity(dispatch, updateGameSession(this.props.gameSession.id, gameSessionModel));

      if (!entityResponse) {
        this.setState({ submitting: false });
        return;
      }

      this.props.history.push(`${this.successRoute()}?message=Updated game session! ${this.state.name}`);
      return;
    } else if (isEdit && !isConfirmEdit) {
      this.setState({ showConfirmSaveModal: true, submitting: false });
      return;
    }

    if (gameSessions.length > 0) {
      this.setState({ submitting: false });
      return this.toastError(sessionNameExistsMessage);
    }

    const hasPlayer = !!player.id;
    const skills = Array.from(new Set(activities.map((activity) => parseInt(activity.skill, 10))));
    const positions = Array.from(new Set(activities.map((activity) => parseInt(activity.position, 10))));
    const difficulties = Array.from(new Set(activities.map((activity) => parseInt(activity.difficulty, 10))));
    const games = Array.from(new Set(activities.map((activity) => parseInt(activity.game, 10))));
    const levels = Array.from(new Set(activities.map((activity) => parseInt(activity.level, 10))));
    const players = [];

    if (hasPlayer) {
      players.push(player.id);
    }

    gameSessionModel.skills = skills;
    gameSessionModel.positions = positions;
    gameSessionModel.difficulties = difficulties;
    gameSessionModel.levels = levels;
    gameSessionModel.games = games;
    gameSessionModel.players = players;

    const gameSessionEntityResponse = await getEntity(dispatch, createGameSession(gameSessionModel));

    if (!player_has_assigned_sessions) {
      this.setState({ sessionActivated: true });
    }

    for (const activity of activities) {
      activity.game_session = gameSessionEntityResponse.id;
      const gameSessionActivityEntityResponse = await getEntity(dispatch, createGameSessionActivity(activity));
      activity.id = gameSessionActivityEntityResponse.id;
    }

    const _gameSessionPatch = {
      activities: activities.map((activity) => activity.id),
    };

    await getEntity(dispatch, updateGameSession(gameSessionEntityResponse.id, _gameSessionPatch));

    if (hasPlayer) {
      const _gameSession = await getEntity(dispatch, getGameSession(gameSessionEntityResponse.id));
      this.setState({ showPlayerModal: true, isEdit: true, gameSession: _gameSession });
    } else {
      this.props.history.push(`${this.successRoute()}?message=Created game session! ${this.state.name}`);
    }

    this.setState({ submitting: false });
  }

  render() {
    const { user } = this.props;

    if (user.limited) {
      return <div className="restore_limited_message">This Page is not available on RESTORE Limited</div>;
    } else {
      return (
        <div className="mp-0">
          <FormSection component={this.sessionDesigner()} />
        </div>
      );
    }
  }

  sessionDesigner = () => {
    const { isTherapistRole, skills, positions, difficulties, games } = this.props;
    const { activities, skill, position, game, player } = this.state;

    let isValidActivity = false;
    if (skill !== '' && position !== '' && game !== '') {
      isValidActivity = true;
    }

    const hasActivities = activities && activities.length > 0 && skills && positions && difficulties && games;

    const activityBuilder = this.activityBuilder(isValidActivity, hasActivities);
    const sessionInformation = this.sessionInformation(isValidActivity, hasActivities);
    const buttons = this.formButtons(hasActivities);
    const playerSaveModal = this.playerSaveModal();
    const isUpdatedSessionModal = this.isUpdatedSessionModal();
    const activitySettingsModal = this.activitySettingsModal(this.state.activities[0]);
    return (
      <div className="mp-0 container-fluid">
        {player.id && (
          <PlayerDashboardButtons player={player} activePage="sessionDesigner" isTherapistRole={isTherapistRole} />
        )}
        <Col className="mp-0 text-left">
          <FormSection
            sectionLabel="Select the skill and position you want to work on"
            sectionInfo="You can change this for each activity"
            component={
              <div className="mp-0 text-left container-fluid">
                {activityBuilder}
                {sessionInformation}
                {buttons}
                {playerSaveModal}
                {isUpdatedSessionModal}
                {activitySettingsModal}
              </div>
            }
          />
        </Col>
      </div>
    );
  };

  activityBuilder = () => {
    return (
      <div className="container-fluid pl-2 pr-1">
        <FormSection sectionNumber={1} sectionLabel="Skill" component={this.skillButtons()} />

        <FormSection sectionNumber={2} sectionLabel="Position" component={this.positionCards()} />

        <FormSection
          sectionNumber={3}
          sectionLabel="Click on a game to add it"
          component={this.gameIcons()}
          headerComponent={this.difficultyInput()}
        />
      </div>
    );
  };

  sessionInformation = () => {
    return (
      <div className="container-fluid pl-2 pr-1">
        <FormSection sectionNumber={4} sectionLabel="Added Activities" component={this.mapActivities()} />

        <FormSection sectionNumber={5} sectionLabel="Review and Save" component={this.reviewAndSave()} />
      </div>
    );
  };

  skillButtons = () => {
    const { skills } = this.props;
    const { skill, position, validGameSkillPositions, availableSkills } = this.state;

    const skillButtons = this.buildSkillButtons(skills, validGameSkillPositions, availableSkills, skill, position);

    return (
      <div className="text-center container-fluid">
        <Row>{skillButtons}</Row>
      </div>
    );
  };

  buildSkillButtons = (skills, validGameSkillPositions, availableSkills, skill, position) => {
    const _skills = skills.filter((_skill) => {
      if (position === '') {
        if (availableSkills.indexOf(_skill.id) !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (!validGameSkillPositions) {
          return false;
        }

        return validGameSkillPositions.indexOf(_skill.id + ',' + position) !== -1;
      }
    });

    return _skills.map((_skill) => {
      return (
        <Col md="2" className="py-1" key={_skill.id}>
          <Pill
            label={_skill.name}
            active={_skill.id === skill}
            onClick={() => {
              const isSet = this.state.skill === _skill.id;
              this.setState({ skill: isSet ? '' : _skill.id });
            }}
          />
        </Col>
      );
    });
  };

  positionCards = () => {
    const { positions } = this.props;
    const { validGameSkillPositions } = this.state;
    const positionCards = this.buildPositionCards(positions, validGameSkillPositions);

    return (
      <div className="container-fluid">
        <Row>{positionCards}</Row>
      </div>
    );
  };

  buildPositionCards = (positions, validGameSkillPositions) => {
    const { skill, position } = this.state;

    const _positions = positions.filter((_position) => {
      if (skill === '') {
        return true;
      } else {
        if (!validGameSkillPositions) {
          return false;
        }

        return validGameSkillPositions.indexOf(skill + ',' + _position.id) !== -1;
      }
    });

    return _positions.map((_position) => {
      let className = 'rounded-circle pointer shadow-sm Game-Session-Form-icon-animation ';
      if (_position.id === position) {
        className += ' Game-Session-Form-icon-active';
      }

      return (
        <div className="mx-2 pb-0 pt-2" key={_position.id}>
          <div
            className="mp-0"
            style={{ width: 85 }}
            onClick={() => {
              const isSet = position === _position.id;
              this.setState({ position: isSet ? '' : _position.id });
            }}
          >
            <PositionIcon className={className} position={_position} showName />
          </div>
        </div>
      );
    });
  };

  difficultyInput = () => {
    const { difficulties } = this.props;
    if (!difficulties) {
      return;
    }

    return (
      <Row className="mr-4 my-auto">
        <Col className="my-auto">
          <span className="mr-3 font-weight-bold text-nowrap">Game Difficulty</span>
        </Col>
        {difficulties.map((difficulty) => this.buildRadioButton(difficulty))}
      </Row>
    );
  };

  checkGamePositionSkillCombo = (gameID, skillID, positionID) => {
    const { game_skill_position } = this.state;

    if (!game_skill_position) {
      return false;
    }

    if (!game_skill_position[gameID]) {
      return false;
    }

    const gameObj = game_skill_position[gameID];

    let currentCombo;
    for (const index in gameObj) {
      currentCombo = gameObj[index];

      if (currentCombo.skill_id === skillID && currentCombo.position_id === positionID) {
        return true;
      }
    }

    return false;
  };

  buildRadioButton = (difficulty) => {
    return (
      <Col className="my-auto">
        <InputRadio
          type="radio"
          name="difficulty"
          id={`difficulty_${difficulty.id}`}
          rlabel={difficulty.name}
          checked={this.state.difficulty === difficulty.id}
          onClick={() => {
            const _difficulty = this.state.difficulty;
            this.setState({ difficulty: difficulty.id !== _difficulty ? difficulty.id : '' });
          }}
        />
      </Col>
    );
  };

  gameIcons = () => {
    const { games } = this.props;
    const { skill, position, difficulty } = this.state;
    const validGames = games.filter(
      (game) =>
        this.checkGamePositionSkillCombo(game.id, skill, position) &&
        (!difficulty || game.difficulties.includes(parseInt(difficulty, 10)))
    );
    const invalidGames = games.filter((game) => {
      return !validGames.find((validGame) => validGame.id === game.id);
    });

    const validGameCards = this.validGameCards(validGames);
    const invalidGameCards = invalidGames.map((validGame) => {
      if (validGame.archived) {
        return '';
      }

      return (
        <div className="mx-2 pt-2 pb-1 text-center" style={{ width: 90 }} key={validGame.id}>
          <GameIcon
            iconClassName="rounded-circle Game-Session-Form-muted-opacity"
            gameIconStyle={{ width: 75 }}
            game={validGame}
            showName
          />
        </div>
      );
    });

    return (
      <div className="container-fluid">
        <Row>
          {validGameCards}
          {invalidGameCards}
        </Row>
      </div>
    );
  };

  validGameCards = (validGames) => {
    return validGames.map((validGame) => {
      return (
        <div className="mx-2 pt-2 pb-1" key={validGame.id}>
          <div
            className="mp-0"
            onClick={() => {
              const { activities, skill, position } = this.state;

              const activity = {
                skill: skill,
                position: position,
                difficulty: validGame.difficulties[0],
                level: validGame.levels[0],
                game: validGame.id,
              };

              activities.push(activity);
              this.setState({ activities, isUpdatedSession: true });
            }}
          >
            <GameIcon
              iconClassName="pointer rounded-circle Game-Session-Form-icon-animation"
              gameIconStyle={{ width: 75 }}
              game={validGame}
              showName
            />
          </div>
        </div>
      );
    });
  };

  mapActivities = () => {
    const { skills, positions, difficulties, levels, games, settings } = this.props;
    const { activities } = this.state;

    const gameOptions = { skills, positions, difficulties, levels, games, settings };

    const activityCards = activities.map((activity, index) => {
      const onClickRemove = () => {
        const { activities } = this.state;
        activities.splice(index, 1);
        this.setState && this.setState({ activities: activities, isUpdatedSession: true });
      };

      const onClickSettings = () => {
        this.setState({
          focusedActivity: activity,
          focusedActivitySettings: activity.settings || {},
          showActivitySettingsModal: true,
          isUpdatedSession: true,
        });
      };

      const onChangeLevel = (level) => {
        activity.level = level;
        this.setState && this.setState({ activity, isUpdatedSession: true });
      };

      return buildActivityCard(activity, gameOptions, false, index, onClickRemove, onClickSettings, onChangeLevel);
    });

    return activityCards && activityCards.length > 0 ? (
      activityCards.map((activity) => (
        <Col md={4} className="m-0 p-1">
          {activity}
        </Col>
      ))
    ) : (
      <h5 className="pl-3 pt-2 Game-Session-Form-muted-opacity">No Activities Created Yet</h5>
    );
  };

  reviewAndSave = () => {
    const { games, positions, skills, label } = this.props;
    const { shareLabel, shareToggle, shareTooltip } = label.sessionDesigner.reviewSave;
    const { activities, player, isAssignedForOOG, isAssignedForHomePlay } = this.state;

    const durationsInMinutes = calculateDurations(games, activities);

    const activitySkills =
      skills &&
      skills.length > 0 &&
      Array.from(new Set(activities.map((activity) => skills.find((skill) => skill.id === activity.skill).name)));
    activitySkills && activitySkills.sort();
    const acitivitySkillsDisplay = activitySkills && activitySkills.join(', ');

    const activityPositions =
      positions &&
      positions.length > 0 &&
      Array.from(
        new Set(activities.map((activity) => positions.find((position) => position.id === activity.position).name))
      );
    activityPositions && activityPositions.sort();
    const acitivityPositionsDisplay = activityPositions && activityPositions.join(', ');

    const homePlayButtonContent = (
      <span>
        <Tooltip title="Assign this session to the player's Home Play plan (requires Home Play activation)">
          <span className="restore_tooltip">
            <i className="fa fa-info-circle"></i>
          </span>
        </Tooltip>{' '}
        Home Play
      </span>
    );

    return (
      <div className="container-fluid text-left">
        <Row className="my-0 py-0">
          <Col md={3} className="m-0 p-0">
            <Input
              name="name"
              value={this.state.name}
              onChange={(name) => {
                this.setState({ name });
              }}
              label="Session Name"
            />
          </Col>
          {activities && activities.length > 0 && (
            <Col className="m-0 mr-0 ml-3 py-1">
              <Col className="border-left">
                <Row className="mx-0 p-0">
                  <h2 className="my-0 ml-0 mr-1 p-0">{durationsInMinutes}</h2>
                  <h5 className="mx-0 mt-auto mb-1 p-0">min</h5>
                </Row>
                <Row className="m-0 p-0">
                  <p className="m-0 p-0 small Game-Session-Form-muted-opacity">Estimated Play Time</p>
                </Row>
              </Col>
            </Col>
          )}

          {activities && activities.length > 0 && (
            <Col className="m-0 px-0 py-1">
              <Col className="border-left">
                <Row className="mx-0 mt-1 p-0">
                  <h4 className="my-0 ml-0 mr-1 p-0">Skill{activitySkills.length > 1 ? 's' : ''}</h4>
                </Row>
                <Row className="m-0 p-0">
                  <p className="m-0 p-0 small Game-Session-Form-muted-opacity">{acitivitySkillsDisplay}</p>
                </Row>
              </Col>
            </Col>
          )}

          {activities && activities.length > 0 && (
            <Col className="m-0 px-0 py-1">
              <Col className="border-left">
                <Row className="mx-0 mt-1 p-0">
                  <h4 className="my-0 ml-0 mr-1 p-0">Position{activityPositions.length > 1 ? 's' : ''}</h4>
                </Row>
                <Row className="m-0 p-0">
                  <p className="m-0 p-0 small Game-Session-Form-muted-opacity">{acitivityPositionsDisplay}</p>
                </Row>
              </Col>
            </Col>
          )}

          {(!activities || activities.length === 0) && (
            <Col className="m-0 p-0">
              <Row className="m-0 p-0">
                <h5 className="center mt-5 Game-Session-Form-muted-opacity">No Activities Created Yet</h5>
              </Row>
            </Col>
          )}
        </Row>
        {player.id && (
          <Row className="my-0 py-0">
            <Col md={5} className="m-0 p-0">
              <div className="container-fluid">
                <Label className="font-weight-bold mb-0">{shareLabel}</Label>
                <Row className="ml-3">
                  {!isAssignedForOOG && (
                    <Button
                      size="sm"
                      color="default"
                      outline
                      className="mr-1 more_restore_button"
                      onClick={this.updateOutOfGymStatus.bind(this)}
                      iconClass="fa-toggle-on fa-flip-horizontal oog_toggle"
                      text={shareToggle}
                    />
                  )}
                  {isAssignedForOOG && (
                    <Button
                      size="sm"
                      color="danger"
                      outline
                      className="mr-1 more_restore_button"
                      onClick={this.updateOutOfGymStatus.bind(this)}
                      iconClass="fa-toggle-on oog_toggle"
                      text={shareToggle}
                    />
                  )}
                  <Tooltip title={shareTooltip}>
                    <span>
                      <i className="fa fa-info-circle"></i>
                    </span>
                  </Tooltip>
                </Row>
              </div>
              <div className="container-fluid" style={{ marginBottom: '10px' }}>
                <div>
                  <Label className="font-weight-bold mb-0">Assign for Home Play:</Label>
                </div>
                {player && !isAssignedForHomePlay && (
                  <Button
                    size="sm"
                    color="default"
                    outline
                    className="mr-1 home_play_button"
                    onClick={this.updateHomePlayStatus.bind(this)}
                    iconClass="fa-toggle-on fa-flip-horizontal home_play_toggle"
                    text={homePlayButtonContent}
                  />
                )}
                {player && isAssignedForHomePlay && (
                  <Button
                    size="sm"
                    color="danger"
                    outline
                    className="mr-1 home_play_button"
                    onClick={this.updateHomePlayStatus.bind(this)}
                    iconClass="fa-toggle-on home_play_toggle"
                    text={homePlayButtonContent}
                  />
                )}
              </div>
            </Col>
          </Row>
        )}

        {player.id && (
          <Row className="my-0 py-0">
            <Col md={5} className="m-0 p-0">
              <div className="container-fluid">
                <Label className="font-weight-bold mb-0">Save to Session Bank?</Label>
                <Row className="ml-3">
                  <InputRadio
                    type="radio"
                    name="isTemplate"
                    id="global_true"
                    rlabel="Yes"
                    checked={this.state.isTemplate}
                    onClick={() => {
                      this.setState({ isTemplate: true });
                    }}
                  />
                  <div className="ml-4">
                    <InputRadio
                      type="radio"
                      name="isTemplate"
                      id="global_false"
                      rlabel="No"
                      checked={!this.state.isTemplate}
                      onClick={() => {
                        this.setState({ isTemplate: false });
                      }}
                    />
                  </div>
                </Row>
              </div>
            </Col>
          </Row>
        )}

        <Row className="my-0 py-0">
          <div className="m-0 p-0 col-9">
            <Input
              name="notes"
              value={this.state.notes}
              onChange={(notes) => {
                this.setState({ notes });
              }}
              placeholder="Notes"
              type="textarea"
            />
          </div>
        </Row>
      </div>
    );
  };

  formButtons = (hasActivities) => {
    const { isEdit, isUpdatedSession, submitting } = this.state;

    return (
      <Row>
        <div className="ml-auto mr-4 my-3">
          {false && (
            <Button
              outline={true}
              className="ml-1"
              text="Duplicate"
              disabled={!hasActivities}
              color="info"
              onClick={() => {
                if (submitting) {
                  return;
                }
                this.props.history.push(this.successRoute());
              }}
            />
          )}
          {isEdit && !isUpdatedSession && (
            <Button
              outline={true}
              className="ml-1"
              text="Archive"
              color="warning"
              onClick={() => {
                this.archiveSession();
              }}
            />
          )}
          <Button
            outline={true}
            className="ml-1"
            text="Cancel"
            color="info"
            onClick={() => {
              if (submitting) {
                return;
              }
              this.props.history.push(this.successRoute());
            }}
          />

          {!submitting && (
            <Button
              text={`Save ${isUpdatedSession && this.state.id ? 'As' : ''}`}
              className="ml-1"
              disabled={!hasActivities}
              color="primary"
              onClick={() => {
                this.submit();
              }}
            />
          )}

          {submitting && (
            <span style={{ marginLeft: '10px' }}>
              Saving Session <i className="fa fa-spinner fa-spin"></i>
            </span>
          )}
        </div>
      </Row>
    );
  };

  playerSaveModal = () => {
    const { currentUserId } = this.props;
    const { player, showPlayerModal, gameSession, sessionActivated } = this.state;

    const modalBody = <span className="font-weight-bold">Session Created for {player.name}!</span>;
    const modalFooter = (
      <div className="mr-0 text-right container-fluid">
        <Button
          className="ml-3"
          color="info"
          outline
          disabled={sessionActivated}
          text={`${sessionActivated ? 'Active Session' : 'Make Active'}`}
          onClick={() => {
            const playerPatch = {
              active_game_session: gameSession.id,
            };

            this.props.dispatch(updatePlayer(player.id, playerPatch)).then(() => {
              player.active_game_session = gameSession.id;
              this.setState({ sessionActivated: true, player: player });
            });
          }}
        />

        <NavLink
          to={{
            pathname: `/player/${player.id}/sessionBank`,
            player: player,
          }}
        >
          <Button className="ml-3" color="success" text="Ok" />
        </NavLink>
        {sessionActivated && (
          <Button
            className="ml-1"
            color="primary"
            text="Play"
            onClick={() => {
              this.onClickPlayActiveSession(player, currentUserId, null, null, true);
            }}
          />
        )}
      </div>
    );

    return this.buildModal(showPlayerModal, null, modalBody, modalFooter);
  };

  isUpdatedSessionModal = () => {
    const { showConfirmSaveModal } = this.state;

    const modalBody = (
      <div>
        <p className="mb-0 pb-0 pl-2 font-weight-bold">Session Activities Updated!</p>
        <p className="mb-0 pb-0 pl-2 small secondary-color">Please give this new session a unique name.</p>
        <Input
          name="name"
          value={this.state.name}
          label="Name"
          onChange={(name) => {
            this.setState({ name });
          }}
        />
      </div>
    );

    const modalFooter = (
      <div className="mr-0 text-right container-fluid">
        <Button
          outline={true}
          className="ml-1"
          text="Cancel"
          color="info"
          onClick={() => {
            this.setState({ showConfirmSaveModal: false });
          }}
        />
        <Button
          className="ml-1"
          color="primary"
          text="Save As"
          onClick={() => {
            this.setState({ showConfirmSaveModal: false });
            this.submit(true);
          }}
        />
      </div>
    );

    return this.buildModal(showConfirmSaveModal, null, modalBody, modalFooter);
  };

  activitySettingsModal = () => {
    const { skills, positions, difficulties, levels, games, settings } = this.props;
    const { focusedActivity, showActivitySettingsModal } = this.state;

    if (!focusedActivity || !games) {
      return;
    }

    const gameOptions = { skills, positions, difficulties, levels, games, settings };

    const activityOptions = getActivityOptions(focusedActivity, gameOptions);
    const skill = activityOptions.skill;
    const position = activityOptions.position;
    const level = activityOptions.level;
    const game = activityOptions.game;

    const _settings = getGameSettings(gameOptions, skill, position, level, game);

    const modalHeader = <span className="font-weight-bold">{game && game.name} Settings</span>;

    const modalBody = (
      <div>{_settings && _settings.map((setting) => this.settingsModalBody(setting, focusedActivity))}</div>
    );

    const modalFooter = (
      <div className="mr-0 text-right container-fluid">
        <Button
          outline={true}
          className="ml-1"
          text="Cancel"
          color="info"
          onClick={() => {
            this.setState({
              showActivitySettingsModal: false,
              focusedActivitySettings: {},
              focusedActivity: {},
            });
          }}
        />
        <Button
          text="Apply"
          className="ml-1"
          color="primary"
          onClick={() => {
            const { focusedActivity, focusedActivitySettings } = this.state;
            focusedActivity.settings = focusedActivitySettings;

            this.setState({
              showActivitySettingsModal: false,
              focusedActivitySettings: {},
              focusedActivity: {},
            });
          }}
        />
      </div>
    );

    return this.buildModal(showActivitySettingsModal, modalHeader, modalBody, modalFooter);
  };

  settingsModalBody = (setting, activity) => {
    const settingStateKey = setting.name;
    const focusedActivitySettings = activity.settings || this.state.focusedActivitySettings;
    const value = focusedActivitySettings[settingStateKey] || setting.default_value;

    const _options = setting && setting.options && Object.keys(setting.options);
    return (
      <InputSelect
        name={setting.name}
        value={value}
        onChange={(settingValue) => {
          const focusedActivitySettings = this.state.focusedActivitySettings;
          focusedActivitySettings[settingStateKey] = settingValue;
          this.setState({ focusedActivitySettings });
        }}
        label={setting.description}
        options={
          _options &&
          _options.map((option) => {
            return (
              <option key={option} className="p-0" value={option}>
                {setting.options[option]}
              </option>
            );
          })
        }
      />
    );
  };

  buildModal(showModal, modalHeader, modalBody, modalFooter) {
    return (
      <Modal isOpen={showModal}>
        {modalHeader && <ModalHeader>{modalHeader}</ModalHeader>}
        {modalBody && <ModalBody>{modalBody}</ModalBody>}
        {modalFooter && <ModalFooter>{modalFooter}</ModalFooter>}
      </Modal>
    );
  }

  async archiveSession() {
    const gameSession = { is_archived: true };
    const entityResponse = await getEntity(
      this.props.dispatch,
      updateGameSession(this.props.gameSession.id, gameSession)
    );

    if (entityResponse) {
      this.props.history.push(`${this.successRoute()}?message=Archived Game Session!`);
    }
  }

  toastError = (message) => {
    toast.error(message, { position: toast.POSITION.TOP_CENTER });
  };
}

const withState = connect((state) => {
  const { game, game_session, game_skill_position, difficulty, level, position, setting, skill, user } = state;

  const validSkillIds =
    game.games &&
    make_array_flat_and_unique(
      game.games.map((game) => {
        return game.skills;
      })
    );
  const validPositionIds =
    game.games &&
    make_array_flat_and_unique(
      game.games.map((game) => {
        return game.positions;
      })
    );
  const validDifficultyIds =
    game.games &&
    make_array_flat_and_unique(
      game.games.map((game) => {
        return game.difficulties;
      })
    );

  const positions = position.positions.filter((position) => {
    return position.image_path !== '';
  });

  return {
    currentUserId: user.currentUserId,
    isTherapistRole: user.isTherapistRole,
    gameSession: game_session.game_session,
    games: game.games,
    user: user,
    difficulties: difficulty.difficulties,
    levels: level.levels,
    positions: positions,
    settings: setting.settings,
    skills: skill.skills,
    game_skill_position: game_skill_position,
    validSkillIds: validSkillIds,
    validPositionIds: validPositionIds,
    validDifficultyIds: validDifficultyIds,
  };
});

export default withWhiteLabelContext(withRouter(withState(SessionDesigner)));
